import { queryOptions } from '@tanstack/react-query'
import { apiFetch } from '#/api/client'

export type WorkspaceTemplate = {
  uuid: string
  name: string
  description: string | null
}

type WorkspaceTemplateListResponse = { data: Array<WorkspaceTemplate> }

export const workspaceTemplatesQueryOptions = queryOptions({
  queryKey: ['workspace-templates'] as const,
  queryFn: async ({ signal }) => {
    const res = await apiFetch<WorkspaceTemplateListResponse>({
      path: '/workspace-templates',
      signal,
    })
    return res.data
  },
  staleTime: 5 * 60 * 1000,
})
